export default () => {
  const scrollBarWidth =
    window.innerWidth - document.documentElement.clientWidth

  /*   if (scrollBarWidth % 2 !== 0) {
    scrollBarWidth += 1
  } */

  document.body.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`)

  // document.documentElement.style.setProperty('--scrollbar-width', `${window.innerWidth - ref.current.offsetWidth}px`)
}
